/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.LearningEventUserRpc
 */

export const getEventsRpc = {
  serviceName: 'com.hubspot.academy.learning.events.rpc.LearningEventUserRpc',
  rpcName: 'getEvents',
  auth: 'app',
  fingerprint: 'yEHVG2b6-K8JTAGBkwYKADAWAf6YdFo-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEventByIdRpc = {
  serviceName: 'com.hubspot.academy.learning.events.rpc.LearningEventUserRpc',
  rpcName: 'getEventById',
  auth: 'app',
  fingerprint: '4IYhRG_IfYL8HWMQK473GzAWAf6YdFo-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEventRecordingRpc = {
  serviceName: 'com.hubspot.academy.learning.events.rpc.LearningEventUserRpc',
  rpcName: 'getEventRecording',
  auth: 'app',
  fingerprint: 'AMdnoUlzBQzC0BRG1mxXTzAWAf6YdFo-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};